// extracted by mini-css-extract-plugin
module.exports = {"root":"DataFeed_root__1_j_8"};